export const providers = {
  FACEBOOK: 'facebook',
  GOOGLE: 'google',
} as const;

export type OAuth2Provider = (typeof providers)[keyof typeof providers];
